import { mapActions, mapGetters, mapState } from "vuex";
import core from "@/mixins/Core";

export default {
  mixins: [core],
  computed: {
    ...mapState(["game", "score", "teams"]),
    ...mapGetters(["findPlayerInGame", "getTeamByPlayer"]),
  },
  methods: {
    ...mapActions(["setScore"]),

    saveAction(data) {
      const playerId = data.playerId;
      const inning = data.inning;
      const action = data.action;
      const positions = data.positions;
      const offenceTeam = data.offenceTeam;
      //const lineUpPosition = this.game[data.offenceTeam].lineUpPosition;
      let team = data.team;
      const score = this.score;

      // Initialisiere das Score-Array, falls es noch nicht existiert
      if (!score.inning) {
        score.inning = [];
      }

      if (!score.id) {
        score.id = this.game.id; // Neues Array für das Inning erstellen
        score.info.date = this.formatDate(Date.now());
        score.startTime = this.formatDate(Date.now(), "HH mm");
      }
      const teams = JSON.parse(JSON.stringify(this.teams));
      if (action === "end") {
        score.status = true;
      }
      score.teams = teams;
      // Spieler im Spiel suchen und Play-Daten vorbereiten
      let playData = {};
      if (playerId) {
        playData.playerId = playerId;
      }
      playData.lineup = data.lineUpPosition;
      playData.action = action;
      playData.positions = {};
      playData.positions[offenceTeam] = JSON.parse(JSON.stringify(positions));
      playData.positions[offenceTeam === "home" ? "guest" : "home"] = JSON.parse(
        JSON.stringify(
          this.game[offenceTeam === "home" ? "guest" : "home"].players
        )
      );
      playData.team = team;
      playData.outs = JSON.parse(JSON.stringify(this.game.outs));
      playData.offenceTeam = offenceTeam;
      //playData.lineUpPosition = lineUpPosition;
      playData.score = {
        home: this.game.home.score,
        guest: this.game.guest.score,
      };
      const lineUpPosition = {
        home:
          offenceTeam === "home"
            ? data.lineUpPosition
            : this.game.home.lineUpPosition,
        guest:
          offenceTeam === "guest"
            ? data.lineUpPosition
            : this.game.guest.lineUpPosition,
      };
      playData.lineUpPosition = lineUpPosition;
      // console.log(score.inning[0])
      if (score.inning[0]) {
        score.inning[0].lineUpPosition = lineUpPosition;
      }
      // score.inning[0].lineUpPosition = lineUpPosition;
      // console.log('playData:', this.score );
      // Sicherstellen, dass das Inning-Objekt existiert
      const lastInning =
        team !== offenceTeam && action === "out" && team === "home"
          ? data.inning - 1
          : data.inning;
      let inningData = score.inning.find((item) => item.inning === lastInning);
      // console.log('InningData:', inningData);
      if (!inningData) {
        inningData = {
          inning: inning,
          play: [],
          lineUpPosition: lineUpPosition,
        };
        score.inning.unshift(inningData);
      }
      // console.log('playData:', playData);
      // Play-Daten zum entsprechenden Inning hinzufügen
      // inningData.lineUpPosition = lineUpPosition;
      inningData.play.unshift(playData);
      // Score speichern
      this.postData("saveScore", score);
    },
  },
};
